/* eslint-disable default-case */
import React from 'react';
import PropTypes from 'prop-types';
import ExternalRedirect from '../ExternalRedirect';
import useMembershipStates from './hooks/useMembershipStates';

// eslint-disable-next-line consistent-return
const MembershipGate = ({children}) => {
  const {state, redirectUrl} = useMembershipStates();

  switch (state) {
    case 'loading':
      return null;
    case 'redirect':
      return <ExternalRedirect absoluteUrl={redirectUrl} />;
    case 'render':
      return children;
  }
};

MembershipGate.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MembershipGate;
